import { render, staticRenderFns } from "./DonutChart20.vue?vue&type=template&id=1eea87c2&scoped=true"
import script from "./DonutChart20.vue?vue&type=script&lang=js"
export * from "./DonutChart20.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eea87c2",
  null
  
)

export default component.exports